<template>
   <el-tabs type="border-card" style="height:auto">
    <el-tab-pane label="线下待开票订单" style="height:auto" >
      <el-form :inline="true" :model="order" class="demo-form-inline">
        <el-form-item label="订单编号">
          <el-input size="mini" v-model.trim="order.orderNo" placeholder="订单编号"></el-input>
        </el-form-item>
        <el-form-item label="登录用户名">
          <el-input size="mini" v-model.trim="order.moblie" placeholder="登录用户名"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button size="mini" type="primary" @click="onSubmit">查询</el-button>
        </el-form-item>
      </el-form>
      <el-table
        :data="data"
        height="710"
        @selection-change="handleSelectionChange"
        border>
        <el-table-column 
          fixed
          type="expand" Scoped slot>
          <template slot-scope="props">
            <el-tabs v-model="activeName" @tab-click="handleClick" style="width:100%">
              <el-tab-pane label="订单详情" name="first">
                <el-table :data="props.row.childList" border style="height:100%;">
                  <el-table-column
                    fixed
                    prop="orderNo"
                    label="子订单编号"
                    width="210">
                  </el-table-column>
                  <el-table-column
                    prop="manufacturerNumber"
                    show-overflow-tooltip
                    label="产品型号"
                    width="160">
                  </el-table-column>
                  <el-table-column
                    prop="brandName"
                    show-overflow-tooltip
                    label="品牌"
                    width="110">
                  </el-table-column>
                  <el-table-column
                    prop="originalPrice"
                    label="商品原价"
                    width="100">
                  </el-table-column>
                  <el-table-column
                    prop="discountedPrice"
                    label="购买价格"
                    width="100">
                  </el-table-column>
                  <el-table-column
                    prop="count"
                    label="购买数量"
                    width="80">
                  </el-table-column>
                  <el-table-column
                    prop="sendCount"
                    label="发货数量"
                    width="80">
                  </el-table-column>
                  <el-table-column
                    prop="attachAmount"
                    label="附加费"
                    width="80">
                  </el-table-column>
                  <el-table-column
                    prop="preferentialMargins"
                    label="总优惠"
                    width="80">
                  </el-table-column>
                  <el-table-column
                    label="状态"
                    width="70">
                    <template slot-scope="scope">
                      <span v-if="scope.row.orderStatus == -4" style="color:#989998">支付失败</span>
                      <span v-if="scope.row.orderStatus == -3" style="color:#989998">已退款</span>
                      <span v-if="scope.row.orderStatus == -2" style="color:#989998">退款申请</span>
                      <span v-if="scope.row.orderStatus == -1" style="color:#989998">已取消</span>
                      <span v-if="scope.row.orderStatus == 0" style="color:#F56C6C">待确认</span>
                      <span v-if="scope.row.orderStatus == 1" style="color:#F56C6C">待付款</span>
                      <span v-if="scope.row.orderStatus == 2" style="color:#E6A23C">部分付款</span>
                      <span v-if="scope.row.orderStatus == 21" style="color:#F56C6C">预付订单</span>
                      <span v-if="scope.row.orderStatus == 3" style="color:#E6A23C">支付成功</span>
                      <span v-if="scope.row.orderStatus == 4" style="color:#67C23A">待发货</span>
                      <span v-if="scope.row.orderStatus == 5" style="color:#67C23A">发货中</span>
                      <span v-if="scope.row.orderStatus == 6" style="color:#409EFF">已发货</span>
                      <span v-if="scope.row.orderStatus == 7" style="color:#989998">已完成</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    prop="totalAmount"
                    label="总金额"
                    width="95">
                  </el-table-column>
                  <el-table-column
                    prop="originalAmount"
                    label="需付金额"
                    width="95">
                  </el-table-column>
                  <el-table-column
                    prop="remark"
                    label="备注">
                  </el-table-column>
                </el-table>
              </el-tab-pane>
              <el-tab-pane label="交易记录" name="third">
                <el-table
                  :data="props.row.payRecordList"
                  style="height:100%;"
                  border>
                  <el-table-column
                    fixed
                    prop="mainOrderNo"
                    label="支付编号"
                    width="220"
                    >
                  </el-table-column>
                  <el-table-column
                    prop="outPayNo"
                    label="第三方支付编号"
                    width="260"
                    >
                  </el-table-column>
                  <el-table-column
                    prop="payType"
                    :formatter="formatPayType"
                    show-overflow-tooltip
                    label="支付类型"
                    width="80"
                    >
                  </el-table-column>
                  <el-table-column
                    prop="payStatus"
                    :formatter="formatPayStatus"
                    label="状态"
                    width="100"
                    >
                  </el-table-column>
                  <el-table-column
                    prop="payMethod"
                    :formatter="formatPay"
                    label="付款方式"
                    width="100"
                    >
                  </el-table-column>
                  <el-table-column
                    prop="payAmount"
                    label="预付金额"
                    width="120">
                  </el-table-column>
                  <el-table-column
                    prop="realAmount"
                    label="已付金额"
                    width="120">
                  </el-table-column>
                  <el-table-column
                    show-overflow-tooltip
                    prop="payTime"
                    label="付款时间">
                  </el-table-column>
                </el-table>
              </el-tab-pane>
              <el-tab-pane label="收货信息" name="second">
                <el-table
                  :data="props.row.userAddressPo"
                  border
                  style="width: 75%">
                  <el-table-column
                    prop="province"
                    show-overflow-tooltip
                    width="120"
                    label="所属省份">
                  </el-table-column>
                  <el-table-column
                    prop="city"
                    show-overflow-tooltip
                    width="120"
                    label="所属市区">
                  </el-table-column>
                  <el-table-column
                    prop="area"
                    show-overflow-tooltip
                    width="120"
                    label="所属地区">
                  </el-table-column>
                  <el-table-column
                    prop="addressDetail"
                    show-overflow-tooltip
                    label="详细地址">
                  </el-table-column>
                  <el-table-column
                    prop="consignee"
                    show-overflow-tooltip
                    width="120"
                    label="联系人">
                  </el-table-column>
                  <el-table-column
                    prop="mobile"
                    show-overflow-tooltip
                    label="联系方式">
                  </el-table-column>
                </el-table>
              </el-tab-pane>
              <el-tab-pane label="发票信息" name="fourth">
                <template v-if="props.row.userInvoiceResponseVo">
                  <el-form>
                    <el-form-item label="发票类型" :label-width="formLabelWidth">
                    <el-select v-model="props.row.userInvoiceResponseVo.type" placeholder="请选择">
                      <el-option
                        v-for="item in options"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                      </el-option>
                    </el-select>
                    </el-form-item>
                    <el-form-item label="发票抬头" :label-width="formLabelWidth"> 
                      <el-input v-model="props.row.userInvoiceResponseVo.companyName"  autocomplete="off"></el-input>
                    </el-form-item>
                    <el-form-item label="税务登记号" :label-width="formLabelWidth">
                      <el-input v-model="props.row.userInvoiceResponseVo.invoiceNumber" autocomplete="off"></el-input>
                    </el-form-item>
                    <el-form-item label="公司注册地址" :label-width="formLabelWidth" v-show="props.row.userInvoiceResponseVo.type == 2">
                      <el-input v-model="props.row.userInvoiceResponseVo.companyAddress" autocomplete="off"></el-input>
                    </el-form-item>
                    <el-form-item label="公司电话" :label-width="formLabelWidth" v-show="props.row.userInvoiceResponseVo.type == 2">
                      <el-input v-model="props.row.userInvoiceResponseVo.companyMobile" autocomplete="off"></el-input>
                    </el-form-item>
                    <el-form-item label="开户银行" :label-width="formLabelWidth" v-show="props.row.userInvoiceResponseVo.type == 2">
                      <el-input v-model="props.row.userInvoiceResponseVo.bankName" autocomplete="off"></el-input>
                    </el-form-item>
                    <el-form-item label="开户银行账号" :label-width="formLabelWidth" v-show="props.row.userInvoiceResponseVo.type == 2">
                      <el-input v-model="props.row.userInvoiceResponseVo.bankNumber" autocomplete="off"></el-input>
                    </el-form-item>
                    <el-form-item label="收票人" :label-width="formLabelWidth" v-show="props.row.userInvoiceResponseVo.type == 2">
                      <el-input v-model="props.row.userInvoiceResponseVo.consignee" autocomplete="off"></el-input>
                    </el-form-item>
                    <el-form-item label="收票地址" :label-width="formLabelWidth" v-show="props.row.userInvoiceResponseVo.type == 2">
                      <el-input v-model="props.row.userInvoiceResponseVo.addressDetail" autocomplete="off"></el-input>
                    </el-form-item>
                    <el-form-item label="手机号码" :label-width="formLabelWidth" v-show="props.row.userInvoiceResponseVo.type == 2">
                      <el-input v-model="props.row.userInvoiceResponseVo.mobile" autocomplete="off"></el-input>
                    </el-form-item>
                    <el-form-item label="电子版盖章开票信息" :label-width="formLabelWidth" v-show="props.row.userInvoiceResponseVo.type == 2">
                      <el-image :src="props.row.userInvoiceResponseVo.invoiceFile" ></el-image>
                    </el-form-item>
                  </el-form>
                </template>
                <template v-else>
                  <div style="padding: 10px 0 20px 0; width: 60%; text-align:center;">
                    暂无
                  </div>
                </template>
              </el-tab-pane>
            </el-tabs>
          </template>
        </el-table-column>
        <el-table-column
          fixed
          type="selection">
        </el-table-column>
        <el-table-column
          fixed
          prop="orderNo"
          label="订单编号"
          show-overflow-tooltip>
        </el-table-column>
        <el-table-column
          prop="createDate"
          show-overflow-tooltip
          label="下单时间">
        </el-table-column>
        <el-table-column
          prop="userName"
          label="用户名"
          show-overflow-tooltip>
        </el-table-column>
        <el-table-column
          prop="consignee"
          label="联系人"
          show-overflow-tooltip>
        </el-table-column>
        <el-table-column
          prop="payAmount"
          label="开票金额">
        </el-table-column>
        <el-table-column
          :formatter="formatInvoice"
          prop="isInvoice"
          label="是否开票"
          show-overflow-tooltip>
        </el-table-column>
        <el-table-column
          fixed="right"
          label="操作">
          <template slot-scope="scope">
            <el-button
              size="mini"
              v-if="scope.row.isInvoice == 1 && (user.isAdmin || user.isFP)"
              @click="openInvoice(scope.row)">专用发票</el-button>
            <el-button
              size="mini"
              v-if="scope.row.isInvoice == 1 && scope.row.userInvoiceResponseVo && scope.row.userInvoiceResponseVo.type == 1 && (user.isAdmin || user.isFP)"
              @click="openInvoice(scope.row)">上传发票</el-button>
          </template>
        </el-table-column>
      </el-table>
      <pagination :pagination="pagination" v-on:paginationClick="queryPagination"></pagination>
    </el-tab-pane>
    <!-- <el-dialog title="发票物流信息" :visible.sync="dialogFormVisible" width="600px">
      <el-form :model="invoiceForm">
        <el-form-item label="订单编号" :label-width="formLabelWidth">
          <el-input v-model="invoiceForm.orderNos" disabled ></el-input>
        </el-form-item>
        <el-form-item label="物流公司" :label-width="formLabelWidth">
          <el-select v-model="invoiceForm.companyId" placeholder="物流公司">
            <el-option
              v-for="item in companyAll.data"
              :key="item.value"
              :label="item.name"
              :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="物流单号" :label-width="formLabelWidth">
          <el-input v-model="invoiceForm.trackNo"  placeholder="请填写物流单号" autocomplete="off"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="cancelShow">取 消</el-button>
        <el-button type="primary" @click="submitOpenInvoice">确 定</el-button>
      </div>
    </el-dialog> -->
    <el-dialog title="发票物流信息" :visible.sync="dialogFormVisible" width="800px">
      <el-form :model="invoiceForm">
        <el-form-item label="订单编号" :label-width="formLabelWidth">
          <el-input v-model="invoiceForm.orderNos" disabled ></el-input>
        </el-form-item>
        <!-- <el-form-item label="上传发票" :label-width="formLabelWidth">
          <el-upload
          class="upload-demo"
          :action="serverUrl"
          :on-success="uploadSuccMethod"
          :on-preview="handlePreview"
          :on-remove="handleRemove"
          :file-list="fileList">
          <el-button size="small" type="primary">点击上传</el-button>
          <div slot="tip" class="el-upload__tip">只能上传jpg/png文件，且不超过500kb</div>
        </el-upload>
        </el-form-item> -->
        <!-- <el-form-item label="物流公司" :label-width="formLabelWidth">
          <el-select v-model="invoiceForm.companyId" placeholder="物流公司">
            <el-option
              v-for="item in companyAll.data"
              :key="item.value"
              :label="item.name"
              :value="item.id">
            </el-option>
          </el-select>
        </el-form-item> -->
        <!-- <el-form-item label="物流单号" :label-width="formLabelWidth">
          <el-input v-model="invoiceForm.trackNo"  placeholder="请填写物流单号" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="物流单号" :label-width="formLabelWidth">
          <el-input v-model="invoiceForm.trackNo"  placeholder="请填写物流单号" autocomplete="off"></el-input>
        </el-form-item> -->
        <el-form-item label="开票金额" :label-width="formLabelWidth">
          <el-input v-model="invoiceForm.invcAmount"  placeholder="开票金额" autocomplete="off" disabled></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="mini" @click="cancelShow">取 消</el-button>
        <el-button size="mini" type="primary" @click="submitOpenInvoice">确 定</el-button>
      </div>
    </el-dialog>
   </el-tabs>
</template>
<script>
import pagination from "../../../common/util/pagination";

export default {
  data() {
    return {
      data: [],
      optionItem: {},
      formLabelWidth: '140px',
      dialogFormVisible:false,
      dialogOrderFormVisible: false,
      activeName: 'first',
      addressList: [],
      payList:[],
      fileList: [],
      serverUrl: "https://admin.ruidan.com/api/upload/load/invcs", // 这里写你要上传的图片服务器地址
      // serverUrl: "http://127.0.0.1:7006/upload/load/invcs",
      invoiceForm: {
        trackNo: '',
        companyId: 3,
        // fileList: [],
        orderNos: '',
        token: this.user.getToken(),
        invcAmount: 0
      },
      companyForm: {
        token: this.user.getToken()
      },
      order: {
        payType: '',
        orderNo: '',
        isInvoice: 1,
        orderStatus:'4',
        token: this.user.getToken()
      },
      invoiceParam: {
        orderNo: '',
        status: 0,
        token: this.user.getToken()
      },
      pagination: {
        pageSize: 10,
        pageNum: 1,
        pageTotal: 0
      },
      companyAll: {
        data: []
      },
      orderNos: '',
      options: [{
          value: 1,
          label: '普通发票'
        }, {
          value: 2,
          label: '专用发票'
        }, {
          value: 3,
          label: '个人'
        }]
    };
  },
  components: {
    pagination
  },
  methods: {
    getExpressCompanyList: function() {
      this.optionItem = this.common.extend(this.companyForm, this.pagination)
      // 初始化默认加载菜单
      this.http.post(
        '/expressCompany/list', 
        this.optionItem, res => {
          if (res.success) {
            // 返回正确的处理
            this.companyAll.data = res.datas.data
          } else {
            // 返回错误的处理
            this.$message.error(res.message)
          }
      });
    },
    handleSelectionChange: function(rows) {
      this.invoiceForm.orderNos = ''
      let userId
      rows.forEach((item) => {
        if (userId) {
          if (userId != item.userId) {
            this.$message.error("不是同一个用户的订单！")
            return
          }
        }
        userId = item.userId
        this.invoiceForm.orderNos += item.orderNo + ','
      })
    },
    formatPay: function(row, column, cellValue) {
      if (cellValue === 1) {
        return "微信";
      } else if (cellValue === 2) {
        return "支付宝";
      } else if (cellValue === 3) {
        return "对公付款";
      }
    },
    formatPayType: function(row, column, cellValue) {
      if (cellValue === 1) {
        return "付款";
      } else if (cellValue === 2) {
        return "附加费";
      } else if (cellValue === 3) {
        return "退款";
      } else if (cellValue === 4) {
        return "部分退还";
      } else if (cellValue === 5) {
        return "优惠退还";
      }
    },
    formatPayStatus: function(row, column, cellValue) {
      if (cellValue === 1) {
        return "未付款";
      } else if (cellValue === 2) {
        return "已付款";
      } else if (cellValue === 3) {
        return "失败";
      } else if (cellValue === 4) {
        return "部分付款";
      }
    },
    formatInvoice: function(row, column, cellValue) {
      if (cellValue === 1) {
        return "未开票";
      } else if (cellValue === 2) {
        return "已开票";
      } else if (cellValue === 3) {
        return "不需要";
      }
    },
    formatAddress: function(row, column, cellValue) {
      if(cellValue) {
        return cellValue.province + ' ' + cellValue.city + ' ' + cellValue.area + ' ' + cellValue.addressDetail;
      }
    },
    formatStatus: function(row, column, cellValue) {
      if (cellValue === 2) {
        return "待审核";
      }else if (cellValue === 1) {
        return "待付款";
      }else if (cellValue === 3) {
        return "待发货";
      }else if (cellValue === 4) {
        return "已发货";
      }
    },
    formatMobile: function(row, column, cellValue) {
      if (cellValue) {
        return cellValue.mobile;
      }
    },
    getOrderData: function() {
      this.optionItem = this.common.extend(this.order, this.pagination);
      // 初始化默认加载菜单
      this.http.post(
        '/offline/order/list',
        this.optionItem,
        res => {
          if (res.success) {
            // 返回正确的处理
            this.data = res.datas.data;
            this.pagination.pageSize = res.datas.page.pageSize
            this.pagination.pageNum = res.datas.page.pageNum
            this.pagination.pageTotal = res.datas.page.pageCount
          } else {
            // 返回错误的处理
            this.$message.error(res.message)
          }
        }
      );
    },
    onSubmit: function() {
      this.pagination.pageNum = 1
      this.getOrderData()
    },
    queryPagination: function(currPage) {
      this.pagination.pageNum = currPage
      this.getOrderData()
    },
    handleClick(sval) {
      if (this.activeName =='six') {
      }
    },
    openInvoice: function(row) {
      this.invoiceForm.orderNos = ''
      this.invoiceForm.invcAmount = row.payAmount
      this.dialogFormVisible = true
      if (!this.invoiceForm.orderNos) {
        this.invoiceForm.orderNos = row.orderNo 
        this.invoiceForm.invcAmount =row.payAmount
      }
      this.getExpressCompanyList()
    },
    uploadSuccMethod(res) {
      this.fileList.push(res.data)
      this.invoiceForm.fileList = this.fileList
    },
    handleRemove(file, fileList) {
      console.log(file, fileList);
    },
    handlePreview(file) {
      console.log(file);
    },
    uploadInvoice: function(row) {
      
    },
    submitOpenInvoice: function() {
      this.http.post(
       '/offline/user/invoice/make',
        this.invoiceForm,
        res => {
          if (res.success) {
            this.invoiceForm.orderNos = ''
            this.dialogFormVisible = false
            // 返回正确的处理
            this.getOrderData()
          } else {
            // 返回错误的处理
            this.$message.error(res.message)
          }
        }
      );
    },
    cancelShow: function() {
      this.dialogFormVisible = false
    },
  },
  mounted: function() {
    this.getOrderData();
  },
};
</script>


<style>
.invoice-css {
  padding: 10px 0 20px 0; width: 60%; text-align:center;
}
.el-table th {
  background: #F5F7FA;
}
.el-table__expanded-cell {  
  padding: 0px 0px 15px 47px !important;
}
.el-tabs {
  border:1px solid #eee;
}
.el-tabs__nav {
  padding: 0 20px;
}
.el-tabs__active-bar {
  margin-left: 20px;
}
.el-input--suffix .el-input__inner {
  padding-right: 16px;
}

.demo-table-expand {
  font-size: 0;
}
.el-form-item__content {
  line-height: none;
}
.el-table .warning-row {
  background: oldlace;
}

.el-table .success-row {
  background: #f0f9eb;
}
.el-table .success-refund{
  background: #FFF;
}
.el-table .success-paid{
  background:#FFF;
}

.el-table .success-over {
  background: #f5f7fa;
}
</style>


// WEBPACK FOOTER //
// src/components/views/invoice/offline/invoiceUnbilledList.vue